import { render } from "./button-reviews.vue?vue&type=template&id=4c247767&scoped=true"
import script from "./button-reviews.vue?vue&type=script&lang=js"
export * from "./button-reviews.vue?vue&type=script&lang=js"

import "./button-reviews.vue?vue&type=style&index=0&id=4c247767&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c247767"]])

export default __exports__